import {
  FETCH_UPDATE_EVENT_REQUEST,
  FETCH_UPDATE_EVENT_SUCCESS,
  FETCH_UPDATE_EVENT_FAILURE,
  SET_UPDATE_EVENT,
  SET_UPDATE_EVENT_DETAILED,
} from "../../actions/events/update-event-actions";

const initialState = {
  updatedEvent: null,
  event: null,
  isLoading: false,
  error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateEventReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_UPDATE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_UPDATE_EVENT:
      console.log("dispatch", "SET_UPDATE_EVENT");
      return {
        ...state,
        isLoading: false,
        error: null,
        event: { ...action.payload },
      };
    case SET_UPDATE_EVENT_DETAILED:
      console.log("dispatch", "SET_UPDATE_EVENT");
      return {
        ...state,
        isLoading: false,
        error: null,
        eventDetailed: { ...action.payload },
      };
    case FETCH_UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updatedEvent: action.payload[0],
      };
    case FETCH_UPDATE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default UpdateEventReducer;
